import React, { Component } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import * as Constanti from '../../Utils/constants.js';
import '../../style/ads.css';


class AdsCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      index: 0,
      loading: true,
      isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    };
    this.intervalId = null;
  }

  async componentDidMount() {
    var apiBaseUrl = Constanti.url_Backend+"allAds";
      var self = this;
      axios.get(apiBaseUrl).then(function (response) {
      if (response.data.data != null){
         var location = response.data.data;
           self.setState({ images: location, loading: false }, () => {
        self.startAutoPlay();
      });
      }else{
        console.log("non ci sono video per questo id");
      }
      self.setState({load:false});
    })
    .catch(function (error) {
    console.log(error);
    self.setState({load:false});
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  startAutoPlay() {
    const { interval = 3000 } = this.props;
    this.intervalId = setInterval(() => {
      this.setState((prev) => ({
        index: (prev.index + 1) % prev.images.length,
      }));
    }, interval);
  }

  render() {
    const { images, index, loading,isMobile } = this.state;
    const {centro} = this.props;

    const adsClass = centro=='true' ? 'adsSectionCentro' : 'adsSectionTop';
    if (loading) return <div>Caricamento ads...</div>;

    return (
    <section className={adsClass} style={{backgroundColor : this.props.color === 'scuro' ? '#0D1623':'transparent' }} >
        <div className="container px-20 max-w-full padding-top-48 paddin-mobile-ads">
          <div className="relative w-full back-white h90 overflow-hidden rounded-2xl shadow-lg flex items-center justify-center bg-gray-100">
            <AnimatePresence>
              <motion.img
                key={images[index]}
                src={Constanti.url_img_new+images[index].thumbnail}
                alt="ad"
                className="absolute h90 w-auto object-contain"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              />
            </AnimatePresence>

            {/* Indicatori */}
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-2">
              {images.map((_, i) => (
                <div
                  key={i}
                  className={`w-2 h-2 rounded-full ${
                    i === index ? "bg-white" : "bg-gray-400"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}


export default AdsCarousel;
